import { IS_DEV } from '@/utils/env';

export const OTHER_LOCATION = {
  location_name: 'Other',
  tel: '800.691.0952',
  full_number: '1.800.691.0952',
  location_page: '/stores/virtual-appointment/',
  location_id: '32180',
};

export const COUNTRY_LOCATIONS = {
  CA: {
    location_name: 'Other',
    tel: '647.498.5665',
    full_number: '647.498.5665',
    location_page: '/en-ca/stores/virtual-appointment/',
    contact_url: '/en-ca/contact/',
  },
  AU: {
    location_name: 'Other',
    tel: '415.426.2781',
    full_number: '415.426.2781',
    location_page: '/en-au/stores/virtual-appointment/',
    contact_url: '/en-au/contact/',
  },
  GB: {
    location_name: 'Other',
    tel: '44.20.3137.1763',
    full_number: '44.20.3137.1763',
    location_page: '/en-gb/stores/virtual-appointment/',
    contact_url: '/en-gb/contact/',
  },
};

export const STATUS_OK = 'ok';
export const STATUS_FAILED = 'failed';
export const USA_COUNTRY = 'US';
export const REFER_URLS = ['/refer', '/refer/'];

export const dataVirtual = {
  additionalAddressDescription: 'From the comfort of your own home',
  modalName: 'Virtual Appointment',
  addressLine1: '',
  displayName1: 'Virtual Appointment',
  displayName2: '',
  hours: '<p>Daily: 7am-6pm PT</p>',
  id: IS_DEV ? '30946' : '30777',
  locationImage: '/bee2-ui/img/virtual-appointment/virtual-desktop.jpeg',
  locationImageAltText: 'A couple booking a Brilliant Earth virtual appointment.',
  mobileLocationImage: '',
  setsterLocationId: 'Virtual Appointment',
  timezoneName: '',
  timezoneAbreviation: 'PT',
  timezoneId: '553',
  storeDescriptionText:
    '<p>Book a virtual appointment with one of our jewelry consultants to experience a 1-on-1 video consultation where you can explore engagement rings, wedding bands, loose gemstones, jewelry, and so much more.</p>',
  storePageLink: '/stores/virtual-appointment/',
};
